(function () {
  'use strict';
  if (window.bmdSizingGuideInit) { window.bmdSizingGuideInit(); return; }
  var initialized = new WeakSet();
  var observed = new WeakSet();
  var sizeRanges = { cuban: [16, 18, 20, 22, 24, 26, 28], tiny: [12, 14, 16] };
  var families = {
    cuban: ['Cuban buckle collars', 'Regular Cuban collars use fixed size labels from 16 to 28 inches, in 2-inch steps.', '16 · 18 · 20 · 22 · 24 · 26 · 28 in'],
    tiny: ['Tiny buckle collars', 'Tiny is its own size range. Choose only among the options shown on that product; there is no 18- or 20-inch Tiny option in the current range.', '12 · 14 · 16 in'],
    other: ['Different gear, different measurement', 'Slip chains must clear the head. Prong collars sit differently. Harnesses need chest measurements. Use the specific product’s guidance or ask us before choosing.', 'This buckle-collar walkthrough is not a fit chart for other gear.']
  };
  function initializeGuide(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    var input = root.querySelector('[data-measurement]');
    var inches = null;
    var family = root.dataset.family in families ? root.dataset.family : 'cuban';
    var result = root.querySelector('[data-result]');
    var note = root.querySelector('[data-result-note]');
    var email = root.querySelector('[data-email-measurement]');
    var offeredMatch = null;
    var useSize = document.createElement('button');
    useSize.type = 'button'; useSize.hidden = true;
    useSize.className = 'bmd-use-measured-size';
    useSize.setAttribute('data-bmd-use-size', '');
    root.querySelector('[data-size-note]').after(useSize);
    var transferNote = root.querySelector('[data-size-note]').parentElement.nextElementSibling;
    var originalTransferNote = transferNote ? transferNote.textContent : '';
    useSize.addEventListener('click', function () {
      var context = handoffContext(root, offeredMatch);
      if (!context || !context.variant.available || useSize.disabled) return;
      context.select.value = context.option;
      context.select.dispatchEvent(new Event('change', {bubbles: true}));
      window.setTimeout(function () {
        if (String(context.master.value) !== String(context.variant.id)) {
          root.querySelector('[data-size-note]').textContent = 'We could not confirm the product selection. Close this guide and choose your size on the product page.';
          return;
        }
        context.form.dispatchEvent(new Event('change', {bubbles: true}));
        var dialog = root.closest('dialog');
        if (dialog) dialog.close();
        context.select.scrollIntoView({behavior: 'smooth', block: 'center'});
        context.select.focus();
      }, 100);
    });
    function number(value) { return Number(value).toFixed(2).replace(/\.00$/, ''); }
    function updateEmail() {
      var measurement = inches === null ? '[Please add your neck measurement in inches]' : number(inches) + ' inches, ' + (root.querySelector('[data-two-finger-confirm]').checked ? 'measured with two fingers underneath, no additional inches added' : 'measurement method not yet confirmed');
      email.href = 'mailto:BMD@badmofodog.com?subject=' + encodeURIComponent('Help with my collar size') + '&body=' + encodeURIComponent('Hello BMD,\n\nPlease help me check the size before I order.\nCollar family: ' + families[family][0] + '\nProduct / color: ' + (root.dataset.productSizeFamily && root.dataset.productSizeFamily !== family ? '[Choose a product in this family]' : (root.dataset.productTitle || '[Please add]')) + '\nNeck measurement: ' + measurement + '\n\nThank you!');
    }
    function renderSize() {
      offeredMatch = null; useSize.hidden = true; useSize.disabled = true;
      if (transferNote) transferNote.textContent = originalTransferNote;
      var output = root.querySelector('[data-size-result]');
      var detail = root.querySelector('[data-size-note]');
      if (family === 'other') { output.textContent = 'Use this product’s own sizing guide.'; detail.textContent = 'The Cuban buckle rule does not apply to slip chains, prong collars or harnesses.'; return; }
      if (root.dataset.productSizeFamily && root.dataset.productSizeFamily !== family) { output.textContent = 'Choose the matching product first.'; detail.textContent = 'This product belongs to ' + families[root.dataset.productSizeFamily][0] + '. Return to that family for this product’s offered sizes.'; return; }
      if (inches === null) { output.textContent = 'Enter your measurement in Step 3.'; detail.textContent = 'Enter a positive measurement in inches.'; return; }
      if (!root.querySelector('[data-two-finger-confirm]').checked) { output.textContent = 'Confirm the two-finger measurement first.'; detail.textContent = 'If you measured directly against the fur, measure again with two fingers underneath.'; return; }
      var sizes = sizeRanges[family];
      if (root.dataset.productSizeFamily === family && root.dataset.productSizeOptions) {
        try {
          sizes = JSON.parse(root.dataset.productSizeOptions).map(function (value) { return Number(String(value).replace(/[^0-9.]/g, '')); }).filter(function (value) { return value > 0 && Number.isFinite(value); }).sort(function (a, b) { return a - b; });
        } catch (ignore) { sizes = []; }
      }
      if (!sizes.length || inches < sizes[0] - 1e-9 || inches > sizes[sizes.length - 1] + 1e-9) {
        output.textContent = 'This reading is outside the listed size range.';
        detail.textContent = 'Ask us about the right collar before ordering. Do not force the nearest size.'; return;
      }
      var match = sizes.find(function (size) { return size + 1e-9 >= inches; });
      output.textContent = 'Choose ' + number(match) + ' inches';
      detail.textContent = 'BMD’s two-finger rule: same size if offered, otherwise the next larger offered size. No extra inches added.';
      offeredMatch = match;
      var context = handoffContext(root, match);
      if (context) {
        if (transferNote) transferNote.textContent = 'Your size changes only when you select Use this size. Check the selected size before adding to cart. Availability is checked for this product; we never substitute a larger size.';
        useSize.hidden = false;
        useSize.textContent = context.variant.available ? 'Use ' + number(match) + '-inch size' : number(match) + '-inch size unavailable';
        useSize.disabled = !context.variant.available;
        if (!context.variant.available) detail.textContent = 'This size is unavailable for your selected options. Ask us before ordering; do not choose a larger size just because it is available.';
      }
    }
    root.querySelector('[data-two-finger-confirm]').addEventListener('change', function () { renderSize(); updateEmail(); });
    function render() {
      if (inches === null) { result.textContent = 'Enter your measurement'; note.textContent = 'Two-finger measurement · no extra inches added'; }
      else { result.textContent = number(inches) + ' inches'; note.textContent = 'Two-finger reading. See the offered size in Step 4.'; }
      updateEmail();
      renderSize();
    }
    function setFamily(value) {
      family = value in families ? value : 'cuban';
      root.dataset.family = family;
      root.querySelectorAll('[data-family-button]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.familyButton === family)); });
      root.querySelectorAll('[data-family-photo]').forEach(function (photo) { photo.hidden = photo.dataset.familyPhoto !== family; });
      root.querySelector('[data-family-photo-wrap]').hidden = family === 'other';
      root.querySelector('[data-family-title]').textContent = families[family][0];
      root.querySelector('[data-family-copy]').textContent = families[family][1];
      root.querySelector('[data-family-sizes]').textContent = families[family][2];
      updateEmail();
      renderSize();
    }
    root.bmdSetFamily = setFamily;
    input.addEventListener('input', function () {
      var raw = input.value.trim().replace(',', '.');
      var valid = /^(?:\d+\.?\d*|\.\d+)$/.test(raw) && Number(raw) > 0 && Number.isFinite(Number(raw));
      inches = valid ? Number(raw) : null;
      input.setAttribute('aria-invalid', String(raw !== '' && !valid));
      render();
      if (raw !== '' && !valid) { result.textContent = 'Use a number greater than 0'; note.textContent = 'For example: 17 or 19.5 inches.'; }
    });
    root.querySelectorAll('[data-tool]').forEach(function (button) {
      button.addEventListener('click', function () {
        var string = button.dataset.tool === 'string';
        root.querySelectorAll('[data-tool]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
        root.querySelector('[data-tape-art]').hidden = string;
        root.querySelector('[data-string-art]').hidden = !string;
        root.querySelector('[data-tape-instructions]').hidden = string;
        root.querySelector('[data-string-instructions]').hidden = !string;
        root.querySelector('[data-tool-name]').textContent = string ? 'a non-stretch shoelace or string' : 'the tape';
        root.querySelector('[data-read-title]').textContent = string ? 'Mark. Remove. Measure.' : 'Read where it meets.';
      });
    });
    root.querySelectorAll('[data-family-button]').forEach(function (button) { button.addEventListener('click', function () { setFamily(button.dataset.familyButton); }); });
    setFamily(location.hash.slice(1) in families ? location.hash.slice(1) : family);
    render();
  }
  function placeLink(link) {
    var form = link.closest('form') || link.closest('[data-product-form]');
    if (!form) return true;
    var sizeSelect = form.querySelectorAll('select.single-option-selector')[Number(link.dataset.bmdOptionIndex || 0)];
    if (!sizeSelect || !sizeSelect.id) return false;
    var existingRow = link.closest('.bmd-fit-selector-heading');
    if (existingRow) {
      var existingLabel = existingRow.querySelector('label');
      if (existingLabel && !existingLabel.htmlFor) existingLabel.htmlFor = sizeSelect.id;
      return true;
    }
    var labels = Array.from(form.querySelectorAll('.selector-wrapper label, .select > label'));
    var label = labels.find(function (l) { return l.textContent.trim().toLowerCase() === (link.dataset.bmdOptionName || '').toLowerCase(); });
    if (!label) return false;
    if (!label.htmlFor) label.htmlFor = sizeSelect.id;
    var row = document.createElement('div'); row.className = 'bmd-fit-selector-heading';
    label.parentNode.insertBefore(row, label); row.appendChild(label); row.appendChild(link);
    return true;
  }
  function initialize() {
    document.querySelectorAll('[data-bmd-guide]').forEach(initializeGuide);
    document.querySelectorAll('[data-bmd-guide-open]').forEach(function (link) {
      if (!placeLink(link)) {
        var form = link.closest('form') || link.closest('[data-product-form]');
        if (form && !observed.has(form)) {
          observed.add(form);
          var observer = new MutationObserver(function () { if (placeLink(link)) observer.disconnect(); });
          observer.observe(form, {childList: true, subtree: true});
          window.setTimeout(function () { observer.disconnect(); }, 10000);
        }
      }
    });

  }

  // BMD size handoff v1: catalog unchanged; regular Cuban sizes only.
  function handoffContext(root, match) {
    if (!Number.isFinite(match) || !activeOpener || !activeOpener.isConnected || !root.closest('dialog') || root.dataset.family !== 'cuban' || activeOpener.dataset.bmdFamily !== 'cuban' || sizeRanges.cuban.indexOf(match) === -1) return null;
    var form = activeOpener.closest('form');
    var wrapper = activeOpener.closest('[data-product-form]');
    if (!form || !wrapper) return null;
    var product;
    try { product = JSON.parse(wrapper.dataset.product); } catch (ignore) { return null; }
    var index = Number(activeOpener.dataset.bmdOptionIndex);
    var selects = Array.from(form.querySelectorAll('select.single-option-selector'));
    var select = selects[index], master = form.querySelector('select[name="id"]');
    if (!select || !master || !Array.isArray(product.variants)) return null;
    var option = Array.from(select.options).find(function (o) { return /^\d+(?:\.\d+)?[\s"”]*$/.test(o.value) && Number(o.value.replace(/[\s"”]/g, '')) === match; });
    if (!option) return null;
    var choices = selects.map(function (x) { return x.value; }); choices[index] = option.value;
    var variant = product.variants.find(function (v) { return v.options.length === choices.length && v.options.every(function (value, i) { return value === choices[i]; }); });
    return variant ? {form: form, select: select, master: master, option: option.value, variant: variant} : null;
  }
  var style = document.createElement('style');
  style.textContent = '.bmd-use-measured-size{padding:12px 18px;background:#d4af37;color:#111;border:0;border-radius:5px;font-weight:700;cursor:pointer;margin-top:12px}.bmd-use-measured-size[hidden]{display:none!important}.bmd-use-measured-size:disabled{opacity:.6;cursor:not-allowed}';
  document.head.appendChild(style);

  var activeOpener = null;
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-bmd-guide-open]');
    if (opener) {
      var dialog = document.querySelector('[data-bmd-guide-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault(); activeOpener = opener;
      dialog.querySelectorAll('[data-bmd-guide]').forEach(function (root) { initializeGuide(root); root.dataset.productTitle = opener.dataset.bmdProductTitle || ''; root.dataset.productSizeOptions = opener.dataset.bmdSizeOptions || ''; root.dataset.productSizeFamily = opener.dataset.bmdFamily || ''; root.bmdSetFamily(opener.dataset.bmdFamily); });
      if (!dialog.open) dialog.showModal();
      dialog.scrollTop = 0; document.body.classList.add('bmd-fit-modal-open');
      dialog.querySelector('[data-bmd-guide-close]').focus();
      return;
    }
    if (event.target.closest('[data-bmd-guide-close]')) {
      var parent = event.target.closest('dialog'); if (parent) parent.close();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var dialog = document.querySelector('[data-bmd-guide-dialog][open]');
    if (!dialog) return;
    var controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex="0"]')).filter(function (element) { return element.getClientRects().length && !element.closest('[hidden]'); });
    if (!controls.length) return;
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) {
      event.preventDefault(); first.focus();
    }
  });
  document.addEventListener('close', function (event) {
    if (!event.target.matches('[data-bmd-guide-dialog]')) return;
    document.body.classList.remove('bmd-fit-modal-open');
    if (activeOpener && activeOpener.isConnected) activeOpener.focus();
  }, true);
  window.bmdSizingGuideInit = initialize;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
}());

/* BMD sizing watch v1: additive player; calculator and commerce unchanged. */
(function () {
  'use strict';
  if (window.bmdSizingWatchInit) { window.bmdSizingWatchInit(); return; }
  var watchedForms = new WeakSet();
  function initializeWatch() {
    document.querySelectorAll('[data-bmd-guide-open]:not([data-bmd-watch-open])').forEach(function (link) {
      var row = link.closest('.bmd-fit-selector-heading');
      if (!row) {
        var host = link.closest('form') || link.closest('[data-product-form]');
        if (host && !watchedForms.has(host)) {
          watchedForms.add(host);
          var observer = new MutationObserver(function () {
            initializeWatch();
            if (host.querySelector('[data-bmd-watch-open]')) observer.disconnect();
          });
          observer.observe(host, {childList: true, subtree: true});
          window.setTimeout(function () { observer.disconnect(); }, 10000);
        }
        return;
      }
      if (row.querySelector('[data-bmd-watch-open]')) return;
      var watch = link.cloneNode(true);
      watch.setAttribute('data-bmd-watch-open', '');
      watch.classList.add('bmd-sizing-watch-link');
      watch.textContent = '▶ Watch how to measure';
      watch.href = '/pages/sizing-guide#bmd-watch-page';
      row.appendChild(watch);
    });
  }
  function playCard(card) {
    if (!card) return;
    var video = card.querySelector('video');
    var button = card.querySelector('[data-bmd-watch-play]');
    var status = card.querySelector('[data-bmd-watch-status]');
    document.querySelectorAll('[data-bmd-watch-video]').forEach(function (other) { if (other !== video) other.pause(); });
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    button.hidden = true;
    video.controls = true;
    status.textContent = '';
    video.addEventListener('error', function () {
      status.textContent = 'Video unavailable? The written steps below still show you how to measure.';
      button.hidden = false;
    }, {once: true});
    card.scrollIntoView({block: 'start', behavior: 'auto'});
    video.focus({preventScroll: true});
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {
      status.textContent = 'Tap the video play control to start.';
      button.hidden = false;
    });
  }
  document.addEventListener('click', function (event) {
    var watch = event.target.closest('[data-bmd-watch-open]');
    if (watch) {
      var dialog = document.querySelector('[data-bmd-guide-dialog][open]');
      if (dialog) playCard(dialog.querySelector('[data-bmd-watch]'));
      return;
    }
    var button = event.target.closest('[data-bmd-watch-play]');
    if (button) { event.preventDefault(); playCard(button.closest('[data-bmd-watch]')); }
  });
  document.addEventListener('close', function (event) {
    if (event.target.matches('[data-bmd-guide-dialog]')) event.target.querySelectorAll('video').forEach(function (v) { v.pause(); });
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) document.querySelectorAll('[data-bmd-watch-video]').forEach(function (v) { v.pause(); });
  });
  window.bmdSizingWatchInit = initializeWatch;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWatch); else initializeWatch();
  document.addEventListener('shopify:section:load', initializeWatch);
}());
